import { createSlice } from "@reduxjs/toolkit";
import { StoreDispatch } from "../store";
import { getWalletReport, ReportsRequest } from "src/network/graphql/analyticsService";
import { Reports } from "../reports/reportsSlice";

const initialReports: Reports[] = [];

const walletReportsSlice = createSlice({
  name: "walletReports",
  initialState: {
    loading: false,
    error: null,
    reports: {
      list: initialReports,
      size: 0
    }
  },
  reducers: {
    fetchReportsStart: (state) => {
      state.loading = true;
    },
    fetchReportsSuccess: (state, action) => {
      state.loading = false;
      state.reports = action.payload;
    },
    fetchReportsFail: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    }
  }
});

const { fetchReportsStart, fetchReportsSuccess, fetchReportsFail } = walletReportsSlice.actions;

export const fetchReportsAction = (data: ReportsRequest) => {
  return async (dispatch: StoreDispatch) => {
    dispatch(fetchReportsStart());
    try {
      const response = await getWalletReport(data);

      dispatch(
        fetchReportsSuccess({
          list: response.data.search_wallet_report.reports,
          size: response.data.search_wallet_report.total_size
        })
      );
    } catch (error) {
      dispatch(fetchReportsFail(error));
    }
  };
};

export default walletReportsSlice.reducer;
